import { render, staticRenderFns } from "./pdfPreview.vue?vue&type=template&id=6a8235fa&scoped=true"
import script from "./pdfPreview.vue?vue&type=script&lang=js"
export * from "./pdfPreview.vue?vue&type=script&lang=js"
import style0 from "./pdfPreview.vue?vue&type=style&index=0&id=6a8235fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8235fa",
  null
  
)

export default component.exports